'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndAddress } from '../../Entities/Ind/IndAddress';
import { IndAddressCollection } from '../../Collections/Ind/IndAddressCollection';

export class IndAddressRepository extends CoreRepository {
  /*public getIndAddress(individualId: number, options: object = {}) {
    if (!options) {
      options = {};
    }
 
    return this.webAPI.getInd(individualId, options)
      .then(response => {
        let user = new Ind();
        user.hydrate(response);
 
        return user;
      });
 
  }
 */

  public createIndAddress(indId: number, payload: any[]) {
    return this.webAPI.createIndAddress(indId, payload).then((response) => {
      const indAddress = new IndAddress();
      indAddress.hydrate(response);

      return indAddress;
    });
  }

  public removeIndAddress(indId: number, indAddressId: number) {
    return this.webAPI.removeIndAddress(indId, indAddressId).then((response) => {
      return response;
    });
  }

  public updateIndAddress(indId: number, indAddressId: number, payload: any[]) {
    return this.webAPI.updateIndAddress(indId, indAddressId, payload).then((response) => {
      return response;
    });
  }

  public moveIndAddress(individualId: number, individualAddressId: number, payload: any[]) {
    return this.webAPI
      .moveIndAddress(individualId, individualAddressId, payload)
      .then((response) => {
        return response;
      });
  }
}
